import { Header, Message, Button } from 'react-frontier';
import styles from '../style/user_account.module.scss';
import { UserCreditsBalance, UserLevelsData, UserLogin } from '../ClassesPublic';
import { useCart } from '../HooksPublic';

var UserAccountBenefits = ({
   levelsData,
   levelsError,
   creditsBalance,
   user
}: {
   levelsData: UserLevelsData | null;
   levelsError: string | null;
   creditsBalance: UserCreditsBalance | null;
   user: UserLogin
}) => {
   var { addRedeemableToCart, cart } = useCart();

   return <div className={styles.flexColumn}>
      <div className={styles.tabContentPadded}>
         {!levelsData && !levelsError 
            && (<div className={styles.centerPad40}>
               <Header loading text="Cargando beneficios..." />
            </div>
         )}
            
         {levelsError 
            && (<div className={styles.padding20}>
               <Message type="error" text={levelsError} />
            </div>
         )}

         {levelsData && !levelsError && (()=>{
            var totalPts=creditsBalance?.available ?? levelsData.total_points ?? 0;
            var levels=[...levelsData.levels].sort((a, b) => a.points - b.points);
            var currentLevelIdx=0;
            
            for(var li = 0; li < levels.length; li++){
               if(totalPts >= levels[li].points){
                  currentLevelIdx = li;
               }else{
                  break;
               }
            }
               
            var nextLevel=currentLevelIdx < levels.length - 1 ? levels[currentLevelIdx + 1] : null;
            var currentLevelMin=levels[currentLevelIdx]?.points ?? 0;
            var nextLevelMin=nextLevel ? nextLevel.points : currentLevelMin;
            var segmentProgress=1;
               
            if(nextLevel){
               segmentProgress = Math.min(1, Math.max(0, (totalPts - currentLevelMin) / (nextLevelMin - currentLevelMin)));
            }

            return <div className={styles.padX4}>
               {levels.length > 0 && (()=>{
                  var totalSegments=levels.length;
                  var fillPct: number;
                        
                  if(!nextLevel){
                     fillPct=100;
                  }else{
                     var baseWidth=(currentLevelIdx / totalSegments) * 100;
                     var segWidth=(1 / totalSegments) * 100;
                     fillPct=baseWidth + segmentProgress * segWidth;
                  }
                  fillPct=Math.min(100, Math.max(0, fillPct));
                        
                  return <div className={styles.mb24}>
                     <div className={styles.flexBetweenMb6}>
                        {levels.map((lv, idx)=>{
                           var isUnlocked=idx <= currentLevelIdx;
                           var isCurrent=idx === currentLevelIdx;
                           return <div 
                              key={`lbl-${lv.level_id}`} 
                              className={styles.levelLabelColumn} 
                              style={{ textAlign: idx === 0 ? 'left' : idx === levels.length - 1 ? 'right' : 'center' }}
                           >
                              <div className={`${styles.levelLabelName} ${isCurrent ? styles.levelLabelCurrent : isUnlocked ? styles.levelLabelUnlocked : styles.levelLabelLocked}`}>
                                 {isCurrent ? '★ ' : ''}{lv.level_name}
                              </div>
                              <div className={styles.levelPts}>{lv.points} pts</div>
                           </div>
                        })}
                     </div>
                     <div className={styles.progressBarBg}>
                        <div 
                           style={{
                              top: 0, 
                              left: 0, 
                              bottom: 0,
                              position: 'absolute', 
                              borderRadius: 99,
                              width: `${fillPct}%`,
                              transition: 'width 0.6s ease',
                              background: 'linear-gradient(90deg, #AC7F5E 0%, #3E2410 100%)',
                           }} 
                        />
                           {levels.length > 1 && levels.slice(0, -1).map((lv, idx) => (
                              <div 
                                 key={`div-${lv.level_id}`} 
                                 style={{
                                    position: 'absolute', top: 0, bottom: 0,
                                    left: `${((idx + 1) / totalSegments) * 100}%`,
                                    width: 2, background: '#fff', transform: 'translateX(-50%)',
                                 }} 
                              />
                           ))}
                        </div>
                        {nextLevel && (
                           <div className={styles.nextLevelHint}>
                              Faltan <b>{Math.max(0, nextLevel.points - totalPts)}</b> pts para <b>{nextLevel.level_name}</b>
                           </div>
                        )}
                        {!nextLevel && (
                           <div className={styles.maxLevelHint}>
                              ¡Estás en el nivel más alto!
                           </div>
                        )}
                  </div>
               })()}

               {levels.length === 0 
                  ? (<div className={styles.emptyCell}>
                     <Header
                        iconName="star"
                        text="Sin niveles desbloqueados aún"
                        size="small"
                        subtext={`Sigue acumulando puntos para desbloquear beneficios exclusivos. Llevas ${totalPts} pts.`}
                     />
                  </div>) 
                  : (levels.map((level, levelIdx) => {
                        var isLevelUnlocked = levelIdx <= currentLevelIdx;
                        var minPts = level.points;
                        var maxPts = levelIdx < levels.length - 1 ? levels[levelIdx + 1].points - 1 : '+';
                           
                        return <div key={`lv-${level.level_id}`} className={styles.mb24}>
                           <div className={styles.levelHeader}>
                              <div className={styles.levelTitle}>{level.level_name}</div>
                              <div className={styles.levelSubtitle}>· {minPts} {maxPts !== '+' ? `a ${maxPts}` : 'en adelante'} pts</div>
                              {isLevelUnlocked && (
                                 <span className={styles.levelBadge}>
                                    {levelIdx === currentLevelIdx ? 'Tu nivel' : 'Desbloqueado'}
                                 </span>
                              )}
                           </div>      
                           {level.products.length === 0 
                              ? (<div className={styles.emptyProducts}>
                                    Sin productos canjeables en este nivel.
                              </div>) 
                              : (<div className={styles.productsGrid}>
                                 {level.products.map(p=>{
                                    var available_pts=creditsBalance?.available ?? 0;
                                    var canRedeem=isLevelUnlocked && available_pts >= p.redeem_points;
                                    var inCart = cart.some(c => c.product_id === p.product_id && c.redeem_points != null);      
                                    return <div 
                                       key={`lv-p-${p.product_id}`} 
                                       style={{
                                          background: inCart ? '#f5f5f5' : '#fff',
                                          border: `1px solid ${inCart ? '#1a1a1a' : '#e0e0e0'}`,
                                          borderRadius: 10,
                                          overflow: 'hidden',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          opacity: isLevelUnlocked || !user.email_confirmed ? (canRedeem ? 1 : 0.6) : 0.4,
                                          position: 'relative',
                                       }}
                                    >
                                       {p.image_url && (
                                          <div className={styles.productImageContainer}>
                                             <img
                                                alt={p.name}
                                                src={p.image_url}
                                                className={styles.productImage}
                                                onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                                             />
                                          </div>
                                       )}
                                       <div className={styles.productInfo}>
                                          {inCart && (
                                             <div className={styles.inCartBadge}>En carrito</div>
                                          )}
                                          <div className={styles.productPoints}>
                                             {p.redeem_points === 0 ? 'Gratis' : `${p.redeem_points} pts`}
                                          </div>
                                          <div style={{ fontWeight: 600, fontSize: 13, color: '#1a1a1a', lineHeight: 1.3, paddingRight: inCart ? 52 : 0, marginTop: 4 }}>
                                             {p.name}
                                          </div>
                                          {!canRedeem && isLevelUnlocked && (
                                             <div className={styles.missingPoints}>
                                                Faltan {p.redeem_points - available_pts} pts
                                             </div>
                                          )}
                                          <Button
                                             size="small"
                                             color="black"
                                             iconName={!isLevelUnlocked ? 'lock' : undefined}
                                             disabled={!canRedeem || inCart || !user.email_confirmed}
                                             text={!user.email_confirmed ? 'Confirma tu correo' : inCart ? 'Agregado' : (!isLevelUnlocked ? `${level.level_name}` : 'Agregar al carrito')}
                                             basic={inCart}
                                             className={styles.mt4}
                                             onClick={canRedeem && !inCart && user.email_confirmed ? () => addRedeemableToCart({ product_id: p.product_id, name: p.name, redeem_points: p.redeem_points }) : undefined}
                                          />
                                       </div>
                                    </div>
                                 })}
                              </div>
                           )}
                        </div>
                  })
               )}
            </div>
         })()}
      </div>
   </div>
};

export default UserAccountBenefits;
